/**
 * @flow
 */
import Box from '@mui/material/Box';
import { SvgIcon, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import BoltIcon from 'assets/icons/bolt.svg';
import AddQuestionButton from 'components/@home/drawers/FormDrawer/AddQuestionButton';
import { Form } from 'formik';
import React from 'react';
import { I18n } from 'utils/i18n';

const StyledForm = styled(Form)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  paddingTop: theme.spacing(8),
  minHeight: '66%',
}));

type Props = {
  onAddQuestion: Function,
};
const FormDrawerQuestionsEmpty = ({ onAddQuestion }: Props) => {
  return (
    <StyledForm>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          width: '50%',
        }}
      >
        <SvgIcon sx={{ fontSize: 48, color: 'greyBlue' }}>
          <BoltIcon />
        </SvgIcon>
        <Typography variant="h5" component="h1" sx={{ my: '20px', whiteSpace: 'pre-line' }}>
          {I18n.t('FormDrawer.Welcome forms')}
        </Typography>
        <AddQuestionButton onAddQuestion={onAddQuestion} isEmpty initiallyOpen />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          width: '50%',
        }}
      >
        <Box
          sx={theme => ({
            background: theme.palette.secondary.ultraUltraLight,
            border: `1px solid ${theme.palette.secondary.extraLight}`,
            borderRadius: '6px',
            p: 4,
            '& ul': {
              padding: '0 0 0 15px',
              listStylePosition: 'outside',
              marginBottom: 0,
              color: theme.palette.secondary.light,
            },
          })}
        >
          <Typography>
            <strong>{I18n.t('FormDrawer.infoBox.title')}</strong>
          </Typography>
          <ul>
            {[1, 2, 3, 4].map(char => (
              <li key={`char.${char}`}>
                <Typography
                  sx={{
                    display: 'inline',
                    color: 'black',
                    verticalAlign: 'middle',
                  }}
                >
                  {I18n.t(`FormDrawer.infoBox.characteristics.${char}`)}
                </Typography>
              </li>
            ))}
          </ul>
        </Box>
      </Box>
    </StyledForm>
  );
};

export default FormDrawerQuestionsEmpty;
